module.exports = __webpack_public_path__ + "assets/img/Fotolia_105030550_XS.9f09c4e5.jpg";